import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, IMAGES } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-navy text-cream relative z-10">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-20 grid md:grid-cols-3 gap-14">
      <div>
        <img src={IMAGES.logo} alt="Beyond Blessed" className="h-14 w-auto mb-5 bg-cream/95 rounded-lg p-1.5" />
        <p className="font-script text-3xl text-goldbright leading-none mb-3">Faith. Healing. Hope.</p>
        <p className="text-cream/60 text-sm max-w-xs">Restoring hearts and renewing minds through faith-based, trauma-informed care in Wesley Chapel & Tampa, FL.</p>
      </div>

      <div>
        <h4 className="font-serif text-xl mb-5 text-goldbright">Explore</h4>
        <ul className="space-y-3 text-cream/70 text-sm">
          <li><Link to="/team" className="hover:text-cream">Meet the Team</Link></li>
          <li><Link to="/retreats" className="hover:text-cream">Therapy Intensives & Retreats</Link></li>
          <li><Link to="/groups" className="hover:text-cream">Therapy Groups</Link></li>
          <li><Link to="/resources" className="hover:text-cream">Books & Courses</Link></li>
          <li><Link to="/blog" className="hover:text-cream">Journal</Link></li>
          <li><Link to="/contact" className="hover:text-cream">Contact</Link></li>
          <li><a href={CONTACT.portal} target="_blank" rel="noreferrer" className="hover:text-cream">Client Portal</a></li>
          <li><a href={CONTACT.growTherapy} target="_blank" rel="noreferrer" className="hover:text-cream">Grow Therapy Clients</a></li>
        </ul>
      </div>

      <div>
        <h4 className="font-serif text-xl mb-5 text-goldbright">Connect</h4>
        <ul className="space-y-4 text-cream/70 text-sm">
          <li className="flex items-start gap-3"><Phone size={17} className="text-goldbright mt-0.5" /><a href={CONTACT.phoneHref} className="hover:text-cream">{CONTACT.phone}</a></li>
          <li className="flex items-start gap-3"><Mail size={17} className="text-goldbright mt-0.5" /><a href={`mailto:${CONTACT.email}`} className="hover:text-cream">{CONTACT.email}</a></li>
          <li className="flex items-start gap-3"><MapPin size={17} className="text-goldbright mt-0.5" /><span>{CONTACT.address}</span></li>
        </ul>
      </div>
    </div>
    <div className="border-t border-cream/10 py-6 text-center text-cream/40 text-xs tracking-wide">
      SAFE SPACE · REAL TALK · LASTING CHANGE — © {new Date().getFullYear()} Beyond Blessed Consulting & Counseling, LLC
    </div>
  </footer>
);
